import * as React from 'react';

/**
 * Where a floating layer (a combobox popup) should mount when it is opened from
 * inside a modal surface.
 *
 * A Radix modal traps focus inside its own content element. A popup portaled to
 * `<body>` sits outside that element, so the moment its search box takes focus
 * the trap pulls focus straight back to the trigger — the popup flickers and
 * the search box can never be typed in. Mounting the popup INSIDE the modal's
 * content keeps it within the trap, so focus, scrolling and screen-reader
 * visibility all behave.
 *
 * `null` (the default) means "not inside such a surface": portal to `<body>`.
 */
const OverlayHostContext = React.createContext<HTMLElement | null>(null);

export function OverlayHostProvider({
    host,
    children,
}: {
    readonly host: HTMLElement | null;
    readonly children: React.ReactNode;
}) {
    return <OverlayHostContext.Provider value={host}>{children}</OverlayHostContext.Provider>;
}

export function useOverlayHost(): HTMLElement | null {
    return React.useContext(OverlayHostContext);
}
